import { CategoryState, RootState } from '@/types/store'
import { GetterTree } from 'vuex'

export interface CategoryGetters extends GetterTree<CategoryState, RootState> {
  parents: (state: CategoryState) => CategoryState['parents']
  children: (state: CategoryState) => CategoryState['children']
}

export const getters: GetterTree<CategoryState, RootState> = {
  parents(state): CategoryState['parents'] {
    return state.parents
  },
  children(state): CategoryState['children'] {
    return state.children
  },
  isCategoryLoading(state): CategoryState['isCategoryLoading'] {
    return state.isCategoryLoading
  },
}
